__turbopack_context__.v({
  "ownerFilter": "FoldersHeader-module__M5zBKa__ownerFilter",
  "root": "FoldersHeader-module__M5zBKa__root",
  "sharing": "FoldersHeader-module__M5zBKa__sharing",
});
